import { Email } from "../components";
import "../styles/Contact.scss";

export const Contact = () => {
  return (
    <article id="contact">
      <div className="content">
        <h1>Ready to work with us?</h1>
        <p>
          Get your estimate by filling out the form below and we will get in
          touch.
        </p>
        <Email />
      </div>
    </article>
  );
};
